import EntitySelector from '@components/EntitySelector'

import useCurrentUser from '@hooks/useCurrentUser'

import useCreateBrandGroupProviderModal from '../../hooks/useCreateBrandGroupProviderModal'

type SelectProviderProps = {
  createBrandGroupProviderModal: ReturnType<typeof useCreateBrandGroupProviderModal>,
  isTopModal: boolean,
}

const SelectProvider = (props: SelectProviderProps) => {
  const { createBrandGroupProviderModal, isTopModal } = props
  const {
    callbacks: {
      addBrandProvider,
    },
    brandGroup,
    formPayload,
  } = createBrandGroupProviderModal

  const {
    entityState: {
      provider_id,
    },
    errors,
    setEntityState,
  } = formPayload

  const { isAdmin } = useCurrentUser()

  return (
    <EntitySelector
      callbacks={{
        selectItem: provider => setEntityState({ provider_id: provider ? provider.id : null }),
      }}
      entityKey="providers"
      errorMessage={errors.provider_id}
      label="* Provider"
      searchForwardProps={{
        listAction: isAdmin && (
          // @ts-expect-error TS2741
          <EntitySelector.CreateEntity
            onClick={() => addBrandProvider()}
            strings={{ create: 'Assign to Brand to enable' }}
          />
        ),
      }}
      searchRequestOptions={{
        assigned_brand_id: brandGroup.brand_id,
        publication_providers: true,
      }}
      selectedItemId={provider_id}
      shouldRefetch={isTopModal}
    />
  )
}

export default SelectProvider
